<script lang="ts" setup>
import type { ResponsiveImageType } from "vue-datocms";
import type { FaqSectionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: FaqSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl flex">
    <div class="px-5xl hidden w-2/5 xl:flex" :class="[data.imagePosition ? 'order-0' : 'order-1']">
      <DatocmsImage v-if="data.image" :data="data.image.responsiveImage as ResponsiveImageType" object-fit="contain" />
    </div>

    <div class="xl:w-3/5">
      <h2 class="mb-lg">
        {{ data.title }}
      </h2>
      <CollapsibleContent v-for="faqItem in data.items" :key="faqItem.id" class="mb-lg" :label="faqItem.question">
        <span class="markdown-content ms-5 inline-block" v-html="faqItem.answer" />
      </CollapsibleContent>
    </div>
  </div>
</template>

<style scoped>

</style>
